export default "__VITE_ASSET__D8YlNBe0__"